<div class="modal-header">
  <h4 class="modal-title" id="modal-title">{{header}}</h4>
  <button type="button"
          class="btn-close"
          aria-describedby="modal-title"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <AdminCard [Item]="PriceEntry">
    <div class="row">
      <div class="col">
        <div class="input-group mb-3">
          <div class="form-floating">
            <input type="number" class="form-control" step="0.01" min="0.01" id="Preis" placeholder="0.00" [(ngModel)]="Item.preis">
            <label for="Preis">{{labelText}}</label>
          </div>
          <span class="input-group-text" id="basic-addon2">€</span>
        </div>
      </div>
    </div>
    <Date-Select [(Date)]="Item.preisBis" LabelText="Gültig ab"></Date-Select>
  </AdminCard>
  <div class="EditBtnRow row">
    <div class="col"></div>
    <div class="col-auto">
      <div class="btn btn-primary" (click)="Send()">Speichern</div>
    </div>
  </div>
</div>
